import { render, staticRenderFns } from "./HistoryKycModal.vue?vue&type=template&id=74dd297c&scoped=true"
import script from "./HistoryKycModal.vue?vue&type=script&lang=js"
export * from "./HistoryKycModal.vue?vue&type=script&lang=js"
import style0 from "./HistoryKycModal.vue?vue&type=style&index=0&id=74dd297c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dd297c",
  null
  
)

export default component.exports